import { useState, useEffect } from "react";
import "./CaseStudy.scss";
import Header from "../../components/Header/Header";
import img21 from "../../assests/img/image 21.svg";
import img24 from "../../assests/img/image 24.svg";
import case1 from "../../assests/img/casestudy.svg";
import Footer from "../../components/Footer/Footer";
import { useParams } from "react-router-dom";
import theData from "../../Data/CaseStudy(Content17).json";
import { fetchCaseStudyById } from "../../services/caseStudyApi";
import { decodeEntityId, buildCaseStudyPath } from "../../util/slugId";
import Seo from "../../components/Seo/Seo";

const CaseStudy = () => {
  const { slug } = useParams();
  const [appData, setAppData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [carousalStatus, setCarousalStatus] = useState(true);

  const handleClick = (data) => {
    setCarousalStatus(data);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const loadCaseStudy = async () => {
      setIsLoading(true);

      try {
        const caseStudyId = decodeEntityId(slug);
        const data = await fetchCaseStudyById(caseStudyId);
        setAppData(data);
      } catch (error) {
        const fallback = theData.find(
          (item) =>
            item.title.toLowerCase().replace(/\s+/g, "-") ===
              slug.toLowerCase() ||
            item.id === slug ||
            item.id === decodeEntityId(slug),
        );
        setAppData(fallback || null);
      } finally {
        setIsLoading(false);
      }
    };

    loadCaseStudy();
  }, [slug]);

  if (isLoading) {
    return (
      <div className="loader-div">
        <div className="loader">
          <lottie-player
            autoplay
            loop
            src="https://lottie.host/7d0ba31f-e11f-47ed-8248-b1a8f5389ad8/oMZAHSKOuQ.json"
          ></lottie-player>
        </div>
      </div>
    );
  }

  if (!appData) {
    return <h2>Case Study Not Found!!!</h2>;
  }

  return (
    <div className="CaseStudy_section">
      <Seo
        title={appData.title}
        description={appData.subTitle}
        path={buildCaseStudyPath(appData.id)}
        type="article"
      />
      <Header handleClick={handleClick} />
      <div className="content">
        <p>{appData.title}</p>
        <p className="fact">{appData.subTitle}</p>
      </div>
      <Card
        className="firstCard"
        im={img21}
        head={appData?.cardDataOne?.heading}
        p1={appData?.cardDataOne?.listData?.[0]?.point}
        p2={appData?.cardDataOne?.listData?.[1]?.point}
        p3={appData?.cardDataOne?.listData?.[2]?.point}
        p4={appData?.cardDataOne?.listData?.[3]?.point}
        p5={appData?.cardDataOne?.listData?.[4]?.point}
      />
      <div className="paraDefine">{appData?.cardDataOne?.aboutDataOne}</div>

      <Cardnew
        flexDirection="row-reverse"
        backgroundColor="white"
        className="secondCard"
        im={img21}
        head={appData?.cardDataTwo?.heading}
        p1={appData?.cardDataTwo?.aboutDataTwo}
      />
      <Card
        className="firstCard"
        im={img24}
        head={appData?.cardDataThree?.heading}
        p1={appData?.cardDataThree?.listData?.[0]?.point}
        p2={appData?.cardDataThree?.listData?.[1]?.point}
        p3={appData?.cardDataThree?.listData?.[2]?.point}
        p4={appData?.cardDataThree?.listData?.[3]?.point}
        p5={appData?.cardDataThree?.listData?.[4]?.point}
      />
      <div className="blackBox">
        <div className="case">
          <img src={case1} alt={appData?.cardDataFour?.heading || "Case study highlight"} />
        </div>
        <div className="blackBox_text">
          <h2>{appData?.cardDataFour?.heading}</h2>
          <p>{appData?.cardDataFour?.aboutDataFour} </p>
        </div>
      </div>

      <div className="passage">
        <p className="titlePassage">{appData?.afterCardDataFour?.heading}</p>
        <p className="textPassage">{appData?.afterCardDataFour?.para}</p>
      </div>
      <div className="lastTextBox">
        <div className="textBox">
          <p className="titlePassage">{appData?.lastData?.heading}</p>
          <p className="textPassage">{appData?.lastData?.aboutLastData}</p>
        </div>

        <div className="box">
          <h2 className="heading">
            {appData?.lastData?.lastDataCard?.heading}
          </h2>
          <p className="para">
            {appData?.lastData?.lastDataCard?.list?.[0]?.point}
          </p>
          <p className="para">
            {appData?.lastData?.lastDataCard?.list?.[1]?.point}
          </p>
          <p className="para">
            {appData?.lastData?.lastDataCard?.list?.[2]?.point}
          </p>
          <p className="para">
            {appData?.lastData?.lastDataCard?.list?.[3]?.point}
          </p>
          <p className="para">
            {appData?.lastData?.lastDataCard?.list?.[4]?.point}
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

function Card(props) {
  return (
    <div className={`card ${props.className}`}>
      <div className="cardImg">
        <img src={props.im} alt={props.head || "Case study illustration"} />
      </div>
      <div className="cardText">
        <h2>{props.head}</h2>
        <ul>
          <li>{props.p1}</li>
          <li>{props.p2}</li>
          <li>{props.p3}</li>
          <li>{props.p4}</li>
          <li>{props.p5}</li>
        </ul>
      </div>
    </div>
  );
}

function Cardnew(props) {
  return (
    <div
      className={`card ${props.className}`}
      style={{
        flexDirection: props.flexDirection,
        backgroundColor: props.backgroundColor,
      }}
    >
      <div className="cardImg">
        <img src={props.im} alt={props.head || "Case study illustration"} />
      </div>
      <div className="cardText">
        <h2>{props.head}</h2>
        <p>{props.p1}</p>
      </div>
    </div>
  );
}

export default CaseStudy;
